// 后端api地址
const DEV_API_URL = 'http://dev.api.caixm.cn/';

const TEST_API_URL = 'http://test.api.caixm.cn/';
const TEST_API_URL_2X = 'http://test.api2x.caixm.cn/';

const PREP_API_URL = 'https://pre.api3x.caixm.cn/';
const PREP_API_URL_2X = 'https://pre.api3x.caixm.cn/';
const PREP_API_URL_3X = 'https://pre.api3x.caixm.cn/';

const PROD_API_URL = 'https://api3x.caixm.cn/';

let api_admin = `${DEV_API_URL}caixmAdmin/`;
let url_store = 'http://test.h5.caixm.cn/#/cml/h5/store';
let api_stall = `${DEV_API_URL}cxm-stall/`; //档主端的接口
let api_export = `${DEV_API_URL}cxm-export/`; // 数据导出
let api_job = `${DEV_API_URL}cxm-job-api/`; // 数据导出

const NODE_ENV = process.env.REACT_APP_API; //process.env.NODE_ENV;

if (NODE_ENV === 'dev') {
  //开发环境
  api_admin = `${DEV_API_URL}caixmAdmin/`;
  url_store = 'http://test.h5.caixm.cn/#/cml/h5/store';
  api_stall = `${DEV_API_URL}cxm-stall/`;
  api_export = `${DEV_API_URL}cxm-export/`;
  api_job = `${DEV_API_URL}cxm-job-api/`;
} else if (NODE_ENV === 'test') {
  //测试环境
  api_admin = `${TEST_API_URL_2X}caixmAdmin/`;
  url_store = 'http://test.h5.caixm.cn/#/cml/h5/store';
  api_stall = `${TEST_API_URL_2X}cxm-stall/`;
  api_export = `${TEST_API_URL}cxm-export/`;
  api_job = `${TEST_API_URL}cxm-job-api/`;
} else if (NODE_ENV === 'preview') {
  //预发布
  api_admin = `${PREP_API_URL_2X}caixmAdmin/`;
  url_store = 'http://pre.newh5.caixm.cn/#/cml/h5/store';
  api_stall = `${PREP_API_URL_3X}cxm-stall/`;
  api_export = `${PREP_API_URL}cxm-export/`;
  api_job = `${PREP_API_URL}cxm-job-api/`;
} else if (NODE_ENV === 'production') {
  //正式环境
  api_admin = `${PROD_API_URL}caixmAdmin/`;
  url_store = 'http://newh5.caixm.cn/#/cml/h5/store';
  api_stall = `${PROD_API_URL}cxm-stall/`;
  api_export = `${PROD_API_URL}cxm-export/`;
  api_job = `${PROD_API_URL}cxm-job-api/`;
  //如果是正式环境，需要从http:跳转到https://
  var protocolStr = document.location.protocol;
  var hostname = document.location.hostname;
  if (protocolStr === 'http:' && hostname !== 'localhost') {
    console.log('protocol = ' + protocolStr);
    var url = window.location.href;
    window.location.href = 'https://' + url.substring(7, url.length);
  }
  //正式环境去掉log日志
  window.console.log = function () {};
} else {
  //本地开发环境
  api_admin = `${DEV_API_URL}caixmAdmin/`;
  // api_admin = 'http://192.168.5.234:8080/caixmAdmin/';
  // api_admin = 'http://pre.api2x.caixm.cn/caixmAdmin/';
  // api_admin = 'https://stall.admin.caixm.cn/caixmAdmin/';

  url_store = 'http://test.h5.caixm.cn/#/cml/h5/store';

  api_stall = `${DEV_API_URL}cxm-stall/`;
  // api_stall = 'http://test.api2x.caixm.cn/cxm-stall/';
  // api_stall = 'http://pre.api3x.caixm.cn/cxm-stall/';
  // api_stall = 'https://stall.mp.caixm.cn/cxm-stall/';

  api_export = `${DEV_API_URL}cxm-export/`;
  // api_export = 'http://192.168.4.95:8088/cxm-export/';

  api_job = `${DEV_API_URL}cxm-job-api/`;
}

export const API_ADMIN = api_admin; //后端接口
export const URL_STORE = url_store; //后端接口
export const API_STALL = api_stall; //后端接口
export const API_EXPORT = api_export; //后端接口
export const API_JOB = api_job; //后端接口
